import { c as _c } from "react/compiler-runtime";
import type { ProfileActivityLog } from "@/entities/IProfile";
import ProfileActivityLogsItem from "./ProfileActivityLogsItem";
import ProfileActivityLogItemWrapper from "./items/utils/ProfileActivityLogItemWrapper";
export default function UserPageIdentityActivityLogList(t0) {
  const $ = _c(10);
  const {
    logs,
    user
  } = t0;
  const t1 = `${user ? "tw-px-4 sm:tw-px-6" : ""} tw-mt-2 tw-pb-2`;
  let t2;
  if ($[0] !== logs || $[1] !== user) {
    let t3;
    if ($[3] !== user) {
      t3 = log => <ProfileActivityLogItemWrapper key={log.id} log={log} user={user}><ProfileActivityLogsItem log={log} user={user} /></ProfileActivityLogItemWrapper>;
      $[3] = user;
      $[4] = t3;
    } else {
      t3 = $[4];
    }
    t2 = logs.map(t3);
    $[0] = logs;
    $[1] = user;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[5] !== t2) {
    t3 = <div className="tailwind-scope tw-inline-block tw-min-w-full tw-align-middle"><table className="tw-min-w-full"><tbody className="tw-divide-y tw-divide-iron-800 tw-divide-solid tw-divide-x-0">{t2}</tbody></table></div>;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t1 || $[8] !== t3) {
    t4 = <div className={t1}>{t3}</div>;
    $[7] = t1;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
}